import { surgeryProcedureAction } from "app/store/dashboard/surgery_types_procedures/actions/surgeryProcedureAction";
import { DEFAULT_SURGERY_PROCEDURE_ID } from "app/store/dashboard/surgery_types_procedures/constants/procedures";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  procedureFilters: {},
  procedureId: DEFAULT_SURGERY_PROCEDURE_ID,
};

const surgeryProcedureSlice = createSlice({
  name: "surgeryProcedure",
  initialState: initialState,
  reducers: surgeryProcedureAction,
});

export const { selectProcedure, resetProcedureFilters, setProcedureCondition } =
  surgeryProcedureSlice.actions;

export default surgeryProcedureSlice.reducer;
